export class Patterns {
  static email = '[a-zA-Z0-9._]{1,}@[a-zA-Z0-9.-]{2,}[.]{1}[a-zA-Z]{2,}'
  static enTxt = '^[a-zA-Z ]+$';
  static arTxt = '^(?=.*[\u0600-\u06FF])[\u0600-\u06FF ]+$';
  static enTxt_Numbers = '^[a-zA-Z0-9 ]+$';
  static noSpecialTxt = '^[a-zA-Z\u0600-\u06FF ]+$';
  static number = '^[0-9]+$';
  static float = '([0-9]+[.])*[0-9]+(?:[0-9]+)?$';
  static quantity = /^\s*(0\.(0*[1-9]|[1-9]\d{0,2})|[1-9]\d{0,5})(\.\d{1,3})?\s*$/;
  static quantity5decimal = /^\s*(0\.(0*[1-9]|[1-9]\d{0,2})|[1-9]\d{0,5})(\.\d{1,5})?\s*$/;
  static quantity5decimalAllowZero = /^\s*(0(\.\d{1,5})?|[1-9]\d{0,5}(\.\d{1,5})?)\s*$/;
  static quantityZero = /^\s*(0\.(0*[0-9]|[0-9]\d{0,2})|[0-9]\d{0,5})(\.\d{1,3})?\s*$/;
  static float2decimal = /^\s*?[1-9]\d*(\.\d{1,2})?\s*$/;
  static price2decimal = /^\s*?[0-9]\d*(\.\d{1,2})?\s*$/;
  static price5decimal = /^\s*?[0-9]\d*(\.\d{1,5})?\s*$/;
  static floatDecimals = /^(0|[1-9]\d{0,3})(\.\d{1,2})?$/;
  static website = /(http|https):\/\/[\w-]+(\.[\w-]+)+([\w.,@?^=%&amp;:\/~+#-]*[\w@?^=%&amp;\/~+#-])?/;
  static enTxtWithSpecial = "^[a-zA-Z0-9- !\"'@#$%^&*()<>?;_+.,:\|=/{}]+$"
  static arTxtWithSpecial = "^(?=.*[\u0600-\u06FF0-9- ])[\u0600-\u06FF0-9- !\"'@#$%^&*()<>?;_+.,:\|=/{}]+$"
  static price = '^[1-9][0-9]*(\.[0-9]+)?|0+\.[0-9]*[1-9][0-9]*$'
  static numbers_plus = '^[\+]?[(]?[0-9]{1,3}[) ]?[-\s\.]?[0-9][-\s\.]?[0-9]{4,10}$'
  static phoneNumber = '[+0-9]+'
  static ipAddress =  /^(?:(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])\.){3}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])$/

  // static arTxtWithSpecial = "^(?=.*[\u0600-\u06FF])[\u0600-\u06FF0-9 !@#$%^&*()]+$"
  // static website = "(https://)?([\\da-z.-]+)\\.([a-z.]{2,6})[/\\w .-_]*/?";
}
